"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var client_1 = require("react-dom/client");
var EntryCommon_1 = require("@components/providers/EntryCommon");
var Index = (0, react_1.lazy)(function () { return Promise.resolve().then(function () { return __importStar(require("@pages/passwordReset/index")); }); });
var Pages = function () { return ((0, jsx_runtime_1.jsx)(EntryCommon_1.EntryCommon, { children: (0, jsx_runtime_1.jsx)(Index, {}) })); };
/**
 * Entry Point
 */
var app = document.getElementById("app");
if (app !== null) {
    (0, client_1.createRoot)(app).render((0, jsx_runtime_1.jsx)(Pages, {}));
}
